var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/plus-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.3069 12.2908V20.1211M20.222 16.206H12.3918M28.0522 16.206C28.0522 22.6927 22.7937 27.9513 16.3069 27.9513C9.8201 27.9513 4.56152 22.6927 4.56152 16.206C4.56152 9.71918 9.8201 4.4606 16.3069 4.4606C22.7937 4.4606 28.0522 9.71918 28.0522 16.206Z",
    stroke: "#0F172A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.531d81558d83b2e1dcc7f15f167614fc.svg";
export { ForwardRef as ReactComponent };